(() => {
  'use strict';

  if (window.__organicTelegramAlertLoaded || window.Shopify?.designMode) return;
  window.__organicTelegramAlertLoaded = true;

  const script = document.currentScript;
  const endpoint = script?.dataset.endpoint;
  const ingestKey = script?.dataset.ingestKey;
  const store = script?.dataset.store;

  if (!endpoint || !ingestKey || !store) return;

  const paidClickKeys = ['gclid', 'gbraid', 'wbraid', 'msclkid'];
  const params = new URLSearchParams(window.location.search);

  function analyticsAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return true;
    return privacy.analyticsProcessingAllowed();
  }

  function isGoogleOrganicLanding() {
    const medium = String(params.get('utm_medium') || '').toLowerCase();
    const source = String(params.get('utm_source') || '').toLowerCase();
    const hasPaidClickId = paidClickKeys.some((key) => params.has(key));
    const isPaidMedium = /^(cpc|ppc|paid|paid-search|display|shopping)$/.test(medium);

    if (hasPaidClickId || isPaidMedium) return false;
    if (source === 'google' && medium === 'organic') return true;
    if (!document.referrer) return false;

    try {
      const referrer = new URL(document.referrer);
      const hostname = referrer.hostname.toLowerCase();
      return /(^|\.)google\./.test(hostname) || hostname === 'com.google.android.googlequicksearchbox';
    } catch (_error) {
      return false;
    }
  }

  function keywordCluster() {
    const path = window.location.pathname.replace(/\/$/, '') || '/';
    const clusters = {
      artperest: [
        [/^\/$/, 'artperest'],
        [/kisiye-ozel-kedi-gozu-kolye/, 'kedi gözü kolye'],
        [/artperest-kisiye-ozel-goz-kolye-tek-ucta-2-goz/, 'kişiye özel göz kolye'],
        [/fotografli-ani-kolye/, 'kişiye özel fotoğraflı anı kolyesi'],
        [/kopek-gozu-kolye/, 'kişiye özel köpek gözü kolye'],
        [/cakmak/, 'tasarım hediyelik çakmak']
      ],
      dalipups: [
        [/^\/$/, 'evcil hayvan portresi / evcil hayvan tablosu'],
        [/^\/en$/, 'custom pet portrait'],
        [/kisiye-ozel-kedi-kanvas-tablo-the-count/, 'kedi portresi / kedi tablosu'],
        [/kopek-kanvas-tablo-the-millionaire-dog/, 'köpek portresi / köpek tablosu'],
        [/evcil-hayvan-portreleri/, 'evcil hayvan portresi'],
        [/ronesans-evcil-hayvan/, 'rönesans evcil hayvan tablosu'],
        [/ladies-of-elegance/, 'rönesans evcil hayvan portresi']
      ]
    };

    const match = (clusters[store] || []).find(([pattern]) => pattern.test(path));
    return match ? match[1] : document.title.replace(/\s*[|–—-]\s*[^|–—-]+$/, '').slice(0, 180);
  }

  function eventId() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, '');
    return `${Date.now()}_${Math.random().toString(36).slice(2)}_${Math.random().toString(36).slice(2)}`;
  }

  function sendAlert() {
    if (!analyticsAllowed() || !isGoogleOrganicLanding()) return;

    const payload = {
      ingest_key: ingestKey,
      event_id: eventId(),
      store,
      path: `${window.location.pathname}${window.location.search}`.slice(0, 500),
      page_title: document.title.slice(0, 250),
      keyword_cluster: keywordCluster()
    };

    window.fetch(endpoint, {
      method: 'POST',
      mode: 'no-cors',
      credentials: 'omit',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    }).catch(() => {});
  }

  window.setTimeout(sendAlert, 750);
  document.addEventListener('visitorConsentCollected', () => window.setTimeout(sendAlert, 250), { once: true });
})();
